import type { FC, SyntheticEvent } from 'react';

import { Button, Dialog, Sheet, Space, Typography } from '@sravni/react-design-system';
import type { SheetProps } from '@sravni/react-design-system/dist/types/components/Sheet';
import { useIsMobile } from '@sravni/react-utils';

import styles from './ServiceBannerInfoSheet.module.scss';
import { ServiceBannerInfoSheetTexts } from './ServiceBannerInfoSheet.texts';

type ServiceBannerInfoSheetProps = {
  visible: boolean;
  onClose: (event: React.MouseEvent | KeyboardEvent | PopStateEvent) => void;
};

export const ServiceBannerInfoSheet: FC<ServiceBannerInfoSheetProps> = ({ visible, onClose }) => {
  const isMobile = useIsMobile();

  const Variant = isMobile ? Sheet : Dialog;

  return (
    <Variant visible={visible} onClose={onClose} className={styles.container}>
      <Variant.Header>
        <Typography.Text size={20} className={styles.header} strong>
          {ServiceBannerInfoSheetTexts.title}
        </Typography.Text>
      </Variant.Header>
      <Variant.Content>
        <Space direction="vertical" size={8}>
          <Typography.Text className={styles.content}>{ServiceBannerInfoSheetTexts.content}</Typography.Text>
          <br />
          <Typography.Text className={styles.content}>{ServiceBannerInfoSheetTexts.description}</Typography.Text>
        </Space>
      </Variant.Content>
      <Variant.Footer>
        <Button onClick={onClose} variant="primary" block size={52}>
          {ServiceBannerInfoSheetTexts.buttonText}
        </Button>
      </Variant.Footer>
    </Variant>
  );
};
